import React from 'react';
import './maintenance.css';
import RevarcLogo from '../../../static/images/revarc_logo_v1.png';
import loginLogo from '../../../static/images/login-logo.png';
import { getIsClaimBridge } from '../auth/Login/functions';

const MaintenancePage = () => {
  return (
    <div className="maintenance-root">

      <div className="maintenance-card">

        {/* Logo — same as login page */}
        <div className="maintenance-logo-wrapper">
          <img
            src={getIsClaimBridge()  ? loginLogo : RevarcLogo}
            alt="RevARC"
            className="maintenance-logo"
          />
        </div>

        {/* Title */}
        <h1 className="maintenance-title">Website Under <br />Maintenance</h1>
        <p className="maintenance-subtitle">We're preparing to serve you better.</p>

        {/* Plug SVG illustration */}
        <div className="maintenance-plug-wrapper" aria-hidden="true">
          <svg
            className="maintenance-plug-svg"
            viewBox="0 0 420 120"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
          >
            {/* ── Left plug (male) ── */}
            {/* Cable line left */}
            <line x1="0" y1="60" x2="120" y2="60" stroke="#b0ccd4" strokeWidth="5" strokeLinecap="round" />
            {/* Plug body left */}
            <rect x="120" y="40" width="60" height="40" rx="6" fill="#e8f4f8" stroke="#4aa8be" strokeWidth="2.5" />
            {/* Prong top */}
            <rect x="178" y="46" width="22" height="8" rx="4" fill="#4aa8be" />
            {/* Prong bottom */}
            <rect x="178" y="66" width="22" height="8" rx="4" fill="#4aa8be" />
            {/* Grip lines */}
            <line x1="138" y1="50" x2="138" y2="70" stroke="#b0ccd4" strokeWidth="2" strokeLinecap="round" />
            <line x1="148" y1="50" x2="148" y2="70" stroke="#b0ccd4" strokeWidth="2" strokeLinecap="round" />

            {/* ── Gap in the middle ── */}
            {/* Spark dots */}
            <circle cx="213" cy="52" r="3" fill="#4aa8be" opacity="0.6">
              <animate attributeName="opacity" values="0.6;0.1;0.6" dur="1.4s" repeatCount="indefinite" />
            </circle>
            <circle cx="208" cy="60" r="2" fill="#4aa8be" opacity="0.4">
              <animate attributeName="opacity" values="0.4;0.1;0.4" dur="1.8s" repeatCount="indefinite" />
            </circle>
            <circle cx="213" cy="68" r="3" fill="#4aa8be" opacity="0.6">
              <animate attributeName="opacity" values="0.6;0.1;0.6" dur="1.2s" repeatCount="indefinite" />
            </circle>

            {/* ── Right plug (female) ── */}
            {/* Cable line right */}
            <line x1="420" y1="60" x2="300" y2="60" stroke="#b0ccd4" strokeWidth="5" strokeLinecap="round" />
            {/* Plug body right */}
            <rect x="240" y="40" width="60" height="40" rx="6" fill="#e8f4f8" stroke="#4aa8be" strokeWidth="2.5" />
            {/* Socket holes */}
            <rect x="240" y="48" width="16" height="8" rx="4" fill="#b0ccd4" />
            <rect x="240" y="64" width="16" height="8" rx="4" fill="#b0ccd4" />
            {/* Grip lines */}
            <line x1="272" y1="50" x2="272" y2="70" stroke="#b0ccd4" strokeWidth="2" strokeLinecap="round" />
            <line x1="282" y1="50" x2="282" y2="70" stroke="#b0ccd4" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        {/* Divider */}
        <div className="maintenance-divider" />

        {/* Contact */}
        <p className="maintenance-contact">
         Thank you for your patience.
          {/* <a href="mailto:support@revarc.com" className="maintenance-link">
            Contact Support
          </a> */}
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
